import { createOwnerJarvisMemoryCaptureCapability, createOwnerJarvisMemoryRecallCapability } from "./capabilities/ownerJarvisMemoryCapabilities";
import { createOwnerJarvisDayFlowCapability } from "./capabilities/ownerJarvisDayFlowCapabilities";
import { createOwnerJarvisRetrospectiveCapability } from "./capabilities/ownerJarvisRetrospectiveCapabilities";
import { createOwnerJarvisImprovementCapability } from "./capabilities/ownerJarvisImprovementCapabilities";
import { createOwnerJarvisFinanceProjectFlowCapability, createOwnerJarvisFinanceQueryCapability } from "./capabilities/ownerJarvisFinanceCapabilities";
import { createOwnerJarvisFinanceSensitiveWriteCapability } from "./capabilities/ownerJarvisFinanceSensitiveCapabilities";
import { createOwnerJarvisProjectCapability } from "./capabilities/ownerJarvisProjectCapabilities";
import { createOwnerJarvisEntityNavigationCapability } from "./capabilities/ownerJarvisNavigationCapabilities";
import { createOwnerJarvisInventoryCapability, createOwnerJarvisOverviewCapability } from "./capabilities/ownerJarvisOverviewCapabilities";
import { createOwnerJarvisVoiceActionCapabilities } from "./ownerJarvisActionRegistry";

// Order is part of the compatibility contract: first handled conversational capability wins.
// UI actions live in this same catalog. A small navigation subset also identifies legacy
// utterances here, so the same operation powers text/voice dispatch and direct UI actions.
export function createOwnerJarvisCapabilities(dependencies) {
  const voiceActions = createOwnerJarvisVoiceActionCapabilities(dependencies);
  return [
    createOwnerJarvisImprovementCapability(dependencies),
    createOwnerJarvisDayFlowCapability(dependencies),
    createOwnerJarvisRetrospectiveCapability(dependencies),
    createOwnerJarvisMemoryCaptureCapability(dependencies),
    createOwnerJarvisFinanceSensitiveWriteCapability(dependencies),
    createOwnerJarvisFinanceProjectFlowCapability(dependencies),
    createOwnerJarvisProjectCapability(dependencies),
    ...voiceActions,
    createOwnerJarvisFinanceQueryCapability(dependencies),
    createOwnerJarvisEntityNavigationCapability(dependencies),
    createOwnerJarvisMemoryRecallCapability(dependencies),
    createOwnerJarvisOverviewCapability(dependencies),
    createOwnerJarvisInventoryCapability(dependencies),
  ];
}
